import InformationSmallBanner from "../../components/InformationSmallBanner/InformationSmallBanner";

import {
  GetInstallationsPaged,
  InstallationsStatistics,
  Installs,
  InstallsCount,
} from "../../services/services";
import { useQuery } from "@tanstack/react-query";
import ResponsiveDataList from "../../components/ResponsiveDataList/ResponsiveDataList";
import { useEffect, useState } from "react";
import TextField from "../../components/Textfield/TextField";
import { SelectCustom } from "../../components/SelectCustom/SelectCustom";
import CloseRedIconSvg from "../../svg/CloseRedIconSvg";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DateObject from "react-date-object";
import Loading from "../../components/Loading/Loading";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { GetUnixDate } from "../../components/GetUnixDate/GetUnixDate";
import { CampaignonvertUnixToGregorian } from "../../components/ConvertUnixToGregorian/ConvertUnixToGregorian";
import { useResponsivePageSize } from "../../hook/useResponsivePageSize";
import useSyncPageSize from "../../hook/useSyncPageSize";
import PersianDate from "../../components/PersianDate/PersianDate";
import MapInstall from "./MapInstall";

const Install = () => {
  const pageSize = useResponsivePageSize();
  const location = useLocation();
  const history = useHistory();
  const getFiltersFromUrl = () => {
    const parsed = queryString.parse(location.search);
    return {
      UserName: parsed.UserName ?? "",
      Serial: parsed.Serial ?? "",
      Code: parsed.Code ?? undefined,
      InstallatopnProductName: parsed.InstallatopnProductName ?? "",
      FromDate: parsed.FromDate ?? "",
      ToDate: parsed.ToDate ?? "",
      OrderBy: parsed.OrderBy ?? "",
      pageNumber: Number(parsed.pageNumber) || 1,
      pageSize: 50,
      IsAscending:
        parsed.IsAscending === "true"
          ? true
          : parsed.IsAscending === "false"
          ? false
          : undefined,
    };
  };

  const [filters, setFilters] = useState(getFiltersFromUrl());
  const [tempFilters, setTempFilters] = useState(filters);
  const [mapInstall, setMapInstall] = useState(false);

  useSyncPageSize(filters, setFilters, pageSize);

  useEffect(() => {
    const query = queryString.stringify(filters, {
      skipNull: true,
      skipEmptyString: true,
    });
    history.replace({ search: `?${query}` });
  }, [filters]);

  const handleChange = (key, value) => {
    setTempFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const { data: getInstallations, refetch } = useQuery({
    queryKey: ["GetInstallationsPaged", filters],
    queryFn: () =>
      GetInstallationsPaged({
        UserName: filters.UserName,
        Serial: filters.Serial,
        Code: filters.Code,
        InstallatopnProductName: filters.InstallatopnProductName,
        FromDate: filters.FromDate
          ? CampaignonvertUnixToGregorian(filters.FromDate)
          : null,
        ToDate: filters.ToDate
          ? CampaignonvertUnixToGregorian(filters.ToDate)
          : null,
        OrderBy: filters.OrderBy,
        IsAscending: filters.IsAscending,
        pageNumber: filters.pageNumber,
        pageSize: filters.pageSize,
      }),
    select: (res) => res,
    enabled: !!filters,
    staleTime: 60 * 60000,
    retry: false,
  });
  const handleSearch = () => {
    setFilters(tempFilters);
    refetch();
  };

  const { data: installationsStatistics } = useQuery({
    queryKey: ["InstallationsStatistics"],
    queryFn: () => InstallationsStatistics(),
    select: (res) => res,
    staleTime: 60 * 60000,
    retry: false,
  });

  const orderByOptions = [{ label: "تاریخ", value: "installDate" }];

  const sortOrderBy = [
    { label: "جدیدترین", value: "false" },
    { label: "قدیمی ترین", value: "true" },
  ];

  const qualityFormatter = (value) => {
    if (value === 1) {
      return "ضعیف";
    } else if (value === 2) {
      return "متوسط";
    } else if (value === 3) {
      return "خوب";
    } else if (value === 4) {
      return "خوب";
    } else if (value === 5) {
      return "عالی";
    } else {
      return "نامشخص";
    }
  };
  const typeFormatter = (value) => {
    let result = "";
    if (value === 1) {
      result = "تابلو";
    } else if (value === 2) {
      result = "شاسی";
    } else if (value === 3) {
      result = "دکا";
    }
    return result;
  };
  const columns = [
    {
      field: "id",
      header: "شناسه",
      style: { textAlign: "right" },
    },
    {
      field: "userName",
      header: "نام",
      style: { textAlign: "right" },
    },
    {
      field: "phoneNumber",
      header: "شماره تماس",
      style: { textAlign: "right" },
    },
    {
      field: "installiationProductName",
      header: "نام محصول	",
      style: { textAlign: "right" },
    },
    {
      body: (rowData) => (
        <div style={{ gap: "10px" }}>
          <span>{rowData?.installProvince} </span>-
          <span> {rowData?.installCity}</span>
        </div>
      ),
      header: "محل نصب	",
      style: { textAlign: "right" },
    },
    {
      field: "installationLocationTypeName",
      header: "نوع کاربری	",
      style: { textAlign: "right" },
    },
    {
      field: "motorTypeName",
      header: "نوع موتور	",
      style: { textAlign: "right" },
    },

    {
      field: "serial",
      header: "سریال محصول	",
      style: { textAlign: "right" },
    },
    {
      field: "code",
      header: " کد کارت خانه ستارگان	",
      style: { textAlign: "right" },
    },
    {
      body: (rowData) => <PersianDate date={rowData.installDate} />,
      field: "installDate",
      header: "تاریخ نصب",
      style: { textAlign: "right" },
    },
    {
      body: (rowData) => typeFormatter(rowData.type),
      header: "نوع محصول	",
      style: { textAlign: "right" },
    },
    {
      body: (rowData) => (
        <div style={{ gap: "10px" }}>
          {rowData?.isSimCharged ? (
            <span
              style={{
                backgroundColor: "#40a737",
                color: "#fff",
                padding: "0px 10px 0px 10px",
                borderRadius: "8px",
              }}
            >
              دریافت شده{" "}
            </span>
          ) : (
            <span
              style={{
                backgroundColor: "#a73737",
                color: "#fff",
                padding: "0px 10px 0px 10px",
                borderRadius: "8px",
              }}
            >
              {" "}
              دریافت نشده{" "}
            </span>
          )}
        </div>
      ),
      header: "وضعیت شارژ	",
      style: { textAlign: "right" },
    },
    {
      field: "quality",
      header: "نظرسنجی",
      style: { textAlign: "right" },
    },
    {
      field: "suggestText",
      header: "پیام",
      style: { textAlign: "right" },
    },
  ];
  const itemTemplate = (item) => (
    <div
      key={item.ID}
      className="rounded shadow-sm mb-3 p-3"
      style={{ backgroundColor: "#f9f9f9", border: "1px solid #eee" }}
    >
      <div className="mb-2 d-flex justify-content-between">
        <span className="text-muted">شناسه:</span>
        <span className="fw-bold farsi-monospace-digit">{item.id}</span>
      </div>
      <hr />
      <div className="mb-1">
        <strong>نام:</strong> {item.name}
      </div>
      <div className="mb-1">
        <strong>موبایل:</strong> {item.phoneNumber}
      </div>
      <div className="mb-1">
        <strong>سریال محصول:</strong> {item.serial}
      </div>
      <div className="mb-1">
        <strong> کد کارت خانه ستارگان :</strong> {item.code}
      </div>
      <div className="mb-1">
        <strong>تاریخ نصب:</strong> {item.installDate}
      </div>
      <div className="mb-1">
        <strong>نوع محصول:</strong> {item.motorTypeName}
      </div>
      <div className="mb-1">
        <strong>نوع کاربری:</strong> {item.installationLocationTypeName}
      </div>
      <div className="mb-1">
        <strong>نوع موتور:</strong> {item.motorTypeName}
      </div>
      <div className="mb-1">
        <strong>نظرسنجی:</strong> {qualityFormatter(item.quality)}
      </div>
      <div className="mb-1">
        <strong>پیام:</strong> {item.suggest}
      </div>
    </div>
  );

  return (
    <div className="custom-container mt-3">
      {getInstallations == undefined && <Loading />}
      {mapInstall ? (
        <MapInstall
          setMapInstall={setMapInstall}
          data={getInstallations?.items}
        />
      ) : (
        <>
          <div className="card mt-3 ">
            <div className="row">
              <div className="col-xl-4 col-6 my-2 ">
                <InformationSmallBanner
                  title={" نصب های امروز "}
                  value={
                    Number(installationsStatistics?.todayInstallations) || 0
                  }
                  background="linear-gradient(135deg, #4e8eff 0%, #6fb1ff 50%, #194daf 100%)"
                />
              </div>
              <div className="col-xl-4 col-6 my-2 ">
                <InformationSmallBanner
                  title=" نصب های این هفته "
                  value={installationsStatistics?.thisWeekInstallations || 0}
                  background="linear-gradient(135deg, #4e8eff 0%, #6fb1ff 50%, #194daf 100%)"
                />
              </div>
              <div className="col-xl-4 col-6 my-2 ">
                <InformationSmallBanner
                  title={" نصب های این ماه "}
                  value={installationsStatistics?.thisMonthInstallations || 0}
                  background="linear-gradient(135deg, #4e8eff 0%, #6fb1ff 50%, #194daf 100%)"
                />
              </div>
            </div>
          </div>
          <div
            style={{
              position: "relative",
              marginTop: "40px",
            }}
            className="card "
          >
            <div
              style={{ display: "flex", gap: "24px", justifyContent: "center" }}
            >
              <button
                style={{
                  backgroundColor: "#fff",
                  padding: "12px 24px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  cursor: "pointer",
                  transition: "background-color 0.3s, transform 0.3s",
                }}
                onClick={() => setMapInstall(false)}
                onMouseOver={(e) =>
                  (e.target.style.backgroundColor = "#f0f0f0")
                }
                onMouseOut={(e) => (e.target.style.backgroundColor = "#fff")}
              >
                <p style={{ margin: 0 }}>فهرست نصب شده ها</p>
              </button>

              <button
                style={{
                  backgroundColor: "#fff",
                  padding: "12px 24px",
                  borderRadius: "8px",
                  border: "1px solid #ccc",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                  cursor: "pointer",
                  transition: "background-color 0.3s, transform 0.3s",
                }}
                onClick={() => setMapInstall(true)}
                onMouseOver={(e) =>
                  (e.target.style.backgroundColor = "#f0f0f0")
                }
                onMouseOut={(e) => (e.target.style.backgroundColor = "#fff")}
              >
                <p style={{ margin: 0 }}>فهرست نصب شده ها در نقشه</p>
              </button>
            </div>

            <div className="background-dataTable">
              <div className="row mt-2">
                <div className="col-12 col-xl-3 col-md-5 mt-md-0 mt-2 mt-md-0 mt-2">
                  <TextField
                    style={{ height: "40px" }}
                    value={tempFilters.UserName}
                    label={"نام کاربری"}
                    onChange={(e) =>
                      setTempFilters({
                        ...tempFilters,
                        UserName: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-12 col-xl-3 col-md-5 mt-md-0 mt-2">
                  <TextField
                    style={{ height: "40px" }}
                    value={tempFilters.InstallatopnProductName}
                    label={" نام محصول "}
                    onChange={(e) =>
                      setTempFilters({
                        ...tempFilters,
                        InstallatopnProductName: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-12 col-xl-3 col-md-5 mt-md-0 mt-2 mt-md-0 mt-2">
                  <TextField
                    style={{ height: "40px" }}
                    value={tempFilters.Serial}
                    label={"سریال محصول"}
                    onChange={(e) =>
                      setTempFilters({ ...tempFilters, Serial: e.target.value })
                    }
                  />
                </div>
                <div className="col-12 col-xl-3 col-md-5 mt-md-0 mt-2">
                  <TextField
                    style={{ height: "40px" }}
                    value={tempFilters.Code}
                    label={" کد کارت خانه ستارگان "}
                    onChange={(e) =>
                      setTempFilters({
                        ...tempFilters,
                        Code: e.target.value,
                      })
                    }
                  />
                </div>

                <div className="col-12 col-xl-3 col-md-5 mt-2">
                  <SelectCustom
                    name="OrderBy"
                    placeholder="مرتب کردن بر اساس"
                    isClearable={true}
                    isSearchable={false}
                    unstyled={true}
                    options={orderByOptions}
                    value={
                      orderByOptions.find(
                        (item) => item.value === tempFilters.OrderBy
                      ) || null
                    }
                    onChange={(e) => {
                      setTempFilters({
                        ...tempFilters,
                        OrderBy: e ? e.value : null,
                      });
                    }}
                  />
                </div>
                {tempFilters.OrderBy && (
                  <div className="col-12 col-xl-3 col-md-5 mt-2">
                    <SelectCustom
                      name="IsAscending"
                      placeholder=" مرتب سازی بر اساس"
                      isClearable={true}
                      isSearchable={false}
                      unstyled={true}
                      options={sortOrderBy}
                      value={
                        sortOrderBy.find(
                          (item) => item.value === tempFilters.IsAscending
                        ) || null
                      }
                      onChange={(e) => {
                        setTempFilters({
                          ...tempFilters,
                          IsAscending: e ? e.value : null,
                        });
                      }}
                    />
                  </div>
                )}
                <div className="col-12 col-xl-3 col-md-5 mt-2">
                  <div
                    style={{
                      display: "inline-block",
                      position: "relative",
                    }}
                  >
                    <DatePicker
                      containerStyle={{
                        height: "40px",
                        borderRadius: "8px",
                        color: "#4b5563",
                        fontSize: "1rem",
                        borderColor: "#c8c8c8",
                        borderWidth: "1px",
                        borderStyle: "solid",
                        width: "210px",
                        display: "flex",
                        paddingRight: "10px",
                        alignItems: "center",
                        boxShadow: "none",
                        backgroundColor: "#1f1f1f",
                      }}
                      inputClass="no-outline"
                      placeholder="تاریخ را انتخاب کنید"
                      style={{ borderRadius: "8px", border: "none" }}
                      calendar={persian}
                      locale={persian_fa}
                      calendarPosition="bottom"
                      range
                      rangeHover
                      value={
                        tempFilters.FromDate && tempFilters.ToDate
                          ? [
                              new DateObject({
                                calendar: persian,
                                date: tempFilters.FromDate,
                              }),
                              new DateObject({
                                calendar: persian,
                                date: tempFilters.ToDate,
                              }),
                            ]
                          : ["", ""]
                      }
                      onChange={(e) => {
                        if (e.length === 2) {
                          handleChange("FromDate", GetUnixDate(e[0]));
                          handleChange("ToDate", GetUnixDate(e[1], true));
                        }
                      }}
                      clearable
                      format="YYYY/MM/DD"
                    />

                    <CloseRedIconSvg
                      onClick={() => {
                        setTempFilters({ FromDate: null, ToDate: null });
                      }}
                      style={{
                        cursor: "pointer",
                        width: "16px",
                        height: "16px",
                        position: "absolute",
                        left: "6px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        zIndex: 100,
                      }}
                    />
                  </div>
                </div>

                <div className="col-6 col-xl-2 col-md-5 d-flex align-items-end mt-md-0 mt-2">
                  <button
                    style={{
                      color: "#ffff",
                      background: "#86a0ff",
                      border: "0px",
                      width: "108px",
                      height: "39px",
                      borderRadius: "8px",
                      padding: "2px",
                    }}
                    onClick={handleSearch}
                  >
                    جستجو
                  </button>
                </div>
              </div>
              <ResponsiveDataList
                dataKey="id"
                data={getInstallations?.items}
                columns={columns}
                itemTemplate={itemTemplate}
                dataViewHeader={<></>}
                className="farsi-monospace-digit "
                rows={filters.pageSize}
                pageNumber={filters.pageNumber}
                totalCount={getInstallations?.totalCount}
                typeFilter={true}
                onPageChange={({ pageNumber }) => {
                  setFilters((prev) => ({
                    ...prev,
                    pageNumber,
                  }));
                }}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default Install;
